"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoucherStore = exports.VoucherState = void 0;
var mobx_1 = require("mobx");
var lang_1 = require("utils/lang");
var MiniTip_1 = require("mobile/components/MiniTip");
var voucher_1 = require("services/nadesico/voucher");
var login_1 = require("mobile/utils/login");
mobx_1.configure({ enforceActions: "observed", isolateGlobalState: true });
var getLang = lang_1.getEzbuyLang();
var VoucherState;
(function (VoucherState) {
    VoucherState[VoucherState["ComingSoon"] = 0] = "ComingSoon";
    VoucherState[VoucherState["GrabNow"] = 1] = "GrabNow";
    VoucherState[VoucherState["FullyRedeemed"] = 2] = "FullyRedeemed";
    VoucherState[VoucherState["Redeemed"] = 3] = "Redeemed";
    VoucherState[VoucherState["Expired"] = 4] = "Expired";
})(VoucherState = exports.VoucherState || (exports.VoucherState = {}));
var VoucherStore = (function () {
    function VoucherStore() {
        var _this = this;
        this.voucherTypes = [];
        this.voucherTypeIds = [];
        this.getVoucherData = function (voucherTypeIds) {
            voucher_1.UserGetMultiVoucherType({
                voucherTypeIds: voucherTypeIds
            }).then(function (_a) {
                var message = _a.message, voucherTypes = _a.voucherTypes;
                if (message === "success") {
                    mobx_1.runInAction(function () {
                        _this.voucherTypes = voucherTypes.filter(function (i) { return i.id && !i.isServerSend; });
                        _this.voucherTypeIds = voucherTypeIds;
                    });
                }
            });
        };
        this.receiveVoucher = function (voucherTypeId) { return __awaiter(_this, void 0, void 0, function () {
            var resp, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, voucher_1.Receive({
                                voucherTypeId: voucherTypeId,
                                channelId: voucher_1.ChannelId.Tights
                            })];
                    case 1:
                        resp = _a.sent();
                        if (resp.code === 200) {
                            this.getVoucherData(this.voucherTypeIds);
                            return [2, true];
                        }
                        else if (resp.code === 403) {
                            login_1.doLogin(location.pathname + location.search);
                            return [2, false];
                        }
                        else if (resp.code === 301) {
                            MiniTip_1.default(getLang("You have reached the voucher redemption limit"), 800);
                            this.getVoucherData(this.voucherTypeIds);
                            return [2, false];
                        }
                        else if (resp.code === 302) {
                            MiniTip_1.default(getLang("Voucher has been Fully Redeemed"), 800);
                            this.getVoucherData(this.voucherTypeIds);
                            return [2, false];
                        }
                        else if (resp.code === 305) {
                            MiniTip_1.default(getLang("Voucher has expired"), 800);
                            this.getVoucherData(this.voucherTypeIds);
                            return [2, false];
                        }
                        else {
                            MiniTip_1.default(resp.message, 800);
                            return [2, false];
                        }
                        return [3, 3];
                    case 2:
                        err_1 = _a.sent();
                        return [2, false];
                    case 3: return [2];
                }
            });
        }); };
        this.getVoucherState = function (ele) {
            var remainTime = ele.remainTime, canReceive = ele.canReceive, receivedCount = ele.receivedCount, remainCount = ele.remainCount;
            if (Number(remainTime) < 0) {
                return VoucherState.ComingSoon;
            }
            else if (Number(remainTime) > 0) {
                if (canReceive && remainCount > 0) {
                    return VoucherState.GrabNow;
                }
                else {
                    if (receivedCount > 0) {
                        return VoucherState.Redeemed;
                    }
                    else {
                        return VoucherState.FullyRedeemed;
                    }
                }
            }
            else {
                return VoucherState.Expired;
            }
        };
    }
    Object.defineProperty(VoucherStore.prototype, "voucherDataArr", {
        get: function () {
            var _this = this;
            return this.voucherTypes.map(function (ele) {
                return {
                    img: ele.img,
                    voucherState: _this.getVoucherState(ele),
                    canReceive: ele.canReceive,
                    remainCount: ele.remainCount,
                    receivedCount: ele.receivedCount,
                    startDate: Number(ele.startDate),
                    endDate: Number(ele.endDate)
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], VoucherStore.prototype, "voucherTypes", void 0);
    __decorate([
        mobx_1.observable
    ], VoucherStore.prototype, "voucherTypeIds", void 0);
    __decorate([
        mobx_1.action
    ], VoucherStore.prototype, "getVoucherData", void 0);
    __decorate([
        mobx_1.action
    ], VoucherStore.prototype, "receiveVoucher", void 0);
    __decorate([
        mobx_1.computed
    ], VoucherStore.prototype, "voucherDataArr", null);
    return VoucherStore;
}());
exports.VoucherStore = VoucherStore;
